
import { isNumber, isString } from 'lodash';
import { useQuasar } from 'quasar';
import { PropType, computed, defineComponent, ref } from 'vue';

import { IconSizeType, iconSizeArray } from 'SharedComponents/ui/Icon/icon';
import { DELAY_TOOLTIP, REGION_ENVIRONMENT } from 'SharedDir/constants/common';

export default defineComponent({
  name: 'SIcon',
  components: {},
  data() {
    return {
      DELAY_TOOLTIP,
    };
  },
  props: {
    size: {
      required: false,
      type: [String, Number] as PropType<IconSizeType | number>,
      // type: String,
      default: 'middle',
    },
    color: {
      required: false,
      type: String,
      default: '',
    },
    tooltip: {
      required: false,
      type: String,
      default: '',
    },
  },

  setup(props, { attrs }) {
    const $q = useQuasar();
    $q.iconMapFn = (iconName) => {
      if (iconName.startsWith('app:')) {
        const name = iconName.substring(4);

        return {
          cls: `uriit-kmns-icon ${name}`,
          content: name,
        };
      }

      if (iconName.startsWith('custom:')) {
        const name = iconName.substring(7);

        return {
          icon: `img:/${REGION_ENVIRONMENT}/icons/custom/${name}.svg`,
        };
      }
    };

    const sizeInner = computed(() => {
      if (isNumber(props.size)) {
        return `${props.size}px`;
      }
      return null;
    });

    const classes = computed(() => {
      let result = 's-icon ';
      if (isString(props.size) && iconSizeArray.includes(props.size)) {
        result += `${props.size} `;
      }
      return result;
    });

    return { classes, sizeInner };
  },
});
